import { Component, Input } from '@angular/core';

import { PaymentMethod } from '@ridango/core';

@Component({
    selector: 'gl-single-payment-portal-method',
    templateUrl: './single-payment-portal-method.component.html',
    styleUrls: ['./single-payment-portal-method.component.scss']
})
export class SinglePaymentPortalMethodComponent {
    @Input() method: PaymentMethod;
    @Input() lang = 'en';
    @Input() showTitle = 'true';
}
